import BackendService from "../core/backend/backend.service";

const AuthenticationGateway = {
    async attempt(username, password) {
        return BackendService.post('authentication', {
            "username": username,
            "password": password
        });
    }
}

export default AuthenticationGateway;


